AgrimarketFactories.factory("currentUserFactory", [
	function () {
		return {
			User: null,
			Connection: null
		};
	}]);